module.exports = __webpack_public_path__ + "static/media/JH_web_5.b0d11ff3.jpg";